import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import {
  getAssetAttributionsPaginated,
  IAssetAttributionPaginatedResponse,
} from "api";
import { Nullable } from "config";
import { RootState } from "store/store";

import { IAssetAttributionModalData } from "./types";
import { AssetAttributionModalMode } from "./enums";

const initialState = {
  assetAttributionData: null as Nullable<
    IAssetAttributionPaginatedResponse["edges"]
  >,
  totalCount: 1,
  loading: false,
  modalData: {
    open: false,
    mode: AssetAttributionModalMode.VIEW,
  } as IAssetAttributionModalData,
};

const actionTypeName = "asset-attribution-type";

export const fetchAssetAttributions = createAsyncThunk(
  `${actionTypeName}/fetchAssetAttributions`,
  async (_, { getState }) => {
    const filters = (getState() as RootState).FiltersReducer;
    if (!Object.values(filters).length) {
      return;
    }

    const response = await getAssetAttributionsPaginated(filters);
    return response;
  }
);

const assetAttributionSlice = createSlice({
  name: actionTypeName,
  initialState,
  reducers: {
    setAssetAttributionModalData: (
      state,
      action: PayloadAction<IAssetAttributionModalData>
    ) => {
      state.modalData = action.payload;
    },
    closeAssetAttributionModal: (state) => {
      state.modalData = initialState.modalData;
    },
    setAssetAttributionModalLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.modalData.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAssetAttributions.fulfilled, (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          loading: false,
        };
      }
      return {
        ...state,
        assetAttributionData: action.payload?.edges,
        totalCount: action.payload?.totalCount,
        loading: false,
      };
    });
    builder.addCase(fetchAssetAttributions.pending, (state) => {
      return {
        ...state,
        loading: true,
      };
    });
  },
});

export const {
  setAssetAttributionModalData,
  closeAssetAttributionModal,
  setAssetAttributionModalLoading,
} = assetAttributionSlice.actions;

export default assetAttributionSlice.reducer;
